import AbstractApiRepository from '~/base/api/AbstractApiRepository';

import { SignInDto } from './dto/SignInDto';

export default class AuthApiRepository extends AbstractApiRepository {
  signIn = (data: SignInDto) => {
    return this.apiClient.post({
      url: `/identity/signin/email`,
      data,
    });
  };
}
